module.exports = __webpack_public_path__ + "static/media/RandomSectionGeometry.a5405918.svg";